// extracted by mini-css-extract-plugin
module.exports = {"optionLabel":"ProductConfigurableBlock_optionLabel__hWc1L"};